import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { SerpApiService } from '../../services/serp-api.service';
import * as SerpApiActions from './serpApi.actions';

@Injectable()
export class SerpApiEffects {
  constructor(
    private actions$: Actions,
    private serpApiService: SerpApiService
  ) {}

  updateSerpApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SerpApiActions.updateSerpApi),
      mergeMap(action =>
        this.serpApiService.updateSerpApi(action.user_id, action.location, action.domain, action.language).pipe(
          map(response => SerpApiActions.updateSerpApiSuccess({ response })),
          catchError(error => of(SerpApiActions.updateSerpApiFailure({ error })))
        )
      )
    )
  );

  loadLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SerpApiActions.loadLocations),
      mergeMap(action =>
        this.serpApiService.getLocations(action.location).pipe(
          map(locations => SerpApiActions.loadLocationsSuccess({ locations })),
          catchError(error => of(SerpApiActions.loadLocationsFailure({ error })))
        )
      )
    )
  );

  loadDomains$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SerpApiActions.loadDomains),
      mergeMap(() =>
        this.serpApiService.getDomains().pipe(
          map(domains => SerpApiActions.loadDomainsSuccess({ domains })),
          catchError(error => of(SerpApiActions.loadDomainsFailure({ error })))
        )
      )
    )
  );

  loadLanguages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SerpApiActions.loadLanguages),
      mergeMap(() =>
        this.serpApiService.getLanguages().pipe(
          map(languages => SerpApiActions.loadLanguagesSuccess({ languages })),
          catchError(error => of(SerpApiActions.loadLanguagesFailure({ error })))
        )
      )
    )
  );

}
